import React, { Component } from 'react';
import classNames from 'classnames';

import { getPropsOrDefault, isEmptyValue } from '../../common/utils.jsx';
import { NODE_TYPE_FIELD } from '../engine/node.types.jsx';
import fieldMap from './fields.map.jsx';

import style from './field.wrapper.less';

const SINGLE_SPACE = ' ';
export default class FieldWrapper extends Component {
  constructor() {
    super();
    this.getValueFrom = this.getValueFrom.bind(this);
  }

  getValueFrom(valuesObject) {
    const name = this.props.name;
    const root = getPropsOrDefault(this, 'props.props.root', undefined);
    if (root) {
      return getPropsOrDefault(
        valuesObject,
        `${root} ${name}`,
        undefined,
        SINGLE_SPACE
      );
    }
    return valuesObject[name];
  }

  shouldComponentUpdate(nextProps) {
    if (
      FieldWrapper.excludedshouldComponentUpdate.includes(this.props.inputType)
    ) {
      return true;
    }
    const fieldValues = this.props.fieldValues;
    const condition = this.props.props.condition;
    const newFieldValues = nextProps.fieldValues;
    const previousValue = this.getValueFrom(fieldValues);
    const nextValue = this.getValueFrom(newFieldValues);
    const valueChanged = previousValue !== nextValue;
    const displayChanged =
      'function' === typeof condition
        ? condition(fieldValues) !== condition(newFieldValues)
        : false;
    return (
      valueChanged ||
      displayChanged ||
      nextProps.isActive !== this.props.isActive
    );
  }

  render() {
    const {
      name,
      inputType,
      nodeType,
      props,
      fieldValues,
      components,
      labelClass,
      isActive,
    } = this.props;
    const { title, condition, root, id } = props;
    let isOpen = true;
    const fullId = root ? `${root}-${id}` : id;
    const hasCondition = 'function' === typeof condition;
    if (hasCondition) {
      isOpen = condition(fieldValues);
    }
    const value = this.getValueFrom(fieldValues);
    if (NODE_TYPE_FIELD !== nodeType) {
      throw new TypeError(
        `FieldWrapper class error: field.nodeType doesn't math ${NODE_TYPE_FIELD}`
      );
    }
    if (isEmptyValue(name)) {
      throw new TypeError(
        `FieldWrapper class error: invalid field name: ${name}`
      );
    }
    if (undefined === fieldMap[inputType]) {
      throw new TypeError(
        `FieldWrapper class error: unknown field type: ${inputType}`
      );
    }
    const ReactField = fieldMap[inputType];
    const labelClassName = classNames(style.label, labelClass);

    if (hasCondition) {
      return isOpen ? (
        <div>
          {title ? (
            <label className={labelClassName} forhtml={id}>
              {title}
            </label>
          ) : null}
          <ReactField
            disabled={!isActive}
            name={name}
            value={value}
            {...props}
            components={components}
            fieldValues={fieldValues}
            id={fullId}
            root={root}
          />
        </div>
      ) : null;
    }

    return (
      <div>
        {title ? (
          <label className={style.label} forhtml={id}>
            {title}
          </label>
        ) : null}
        <ReactField
          disabled={!isActive}
          name={name}
          value={value}
          {...props}
          components={components}
          fieldValues={fieldValues}
          id={fullId}
          root={root}
        />
      </div>
    );
  }
}
FieldWrapper.excludedshouldComponentUpdate = [
  'PersonsArray',
  'AjaxAutocomplete',
  'CheckboxButtons',
  'AutocompleteCheckboxButtons',
  'AutocompleteCheckboxButtonsWithAge',
  'Multibirth',
  'FamilyCancerHistory',
];
